import Settings from 'components/CookieOverlay/Settings';
import RoundedButton from 'components/RoundedButton';
import React, { useCallback, useMemo, useState } from 'react';
import ExcludeOnPlatforms from '../../hoc/ExcludeOnPlatforms';
import classnames from 'classnames';
import { useCookieConsent } from 'providers/CookieConsentProvider';
import { Trek } from 'utils/analytics';

const CSS = require('./CookieOverlay.less');

export function CookieOverlay() {
  const { setConsent, ...consentState } = useCookieConsent()
  // the localState is the unsaved/unsubmitted state
  const [localState, setLocalState] = useState({
    showSettings: false,
    social: true,
    advertisement: true,
    accepted: true,
  });

  const onAcceptClick = useCallback(() => {
    setConsent({ base: true, social: localState.social, advertisement: localState.advertisement, location: consentState.location })
  }, [setConsent, localState.advertisement, localState.social, consentState.location])

  const onChangeSettingsClick = useCallback((e: any) => {
    setLocalState({ ...localState, showSettings: true });
  }, [localState]);

  const onSettingChange = useCallback(({ target }: {target: { checked: boolean; name: 'social' | 'advertisement' }}) => {
    setLocalState({
      ...localState,
      [target.name]: target.checked,
    });
  }, [localState])
  const trekkerContext = useMemo(() => ({
    component: ['cookie-consent'],
    cookieConsent: {
      functional: localState.accepted,
      analytics: localState.accepted,
      social: localState.social,
      advertisement: localState.advertisement,
      location: consentState.location
    }
  }), [localState.accepted, localState.advertisement, localState.social, consentState.location])

  if (consentState.base) {
    return null;
  }
  return (
    <Trek context={trekkerContext}>
      <aside className={CSS.Container}>
        <div
          data-test-id="CookieOverlay"
          className={classnames(CSS.CookieOverlay, { [CSS.CookieOverlayWithSettings]: localState.showSettings })}
        >
          <h2 className={CSS.Title}>
            Cookie Consent
          </h2>
          {!localState.showSettings &&
            <p className={CSS.Disclaimer}>
              We use cookies to make sure we give you the best user experience on our platform! Furthermore we use cookies for analytics & marketing purposes.
            </p>
          }
          {localState.showSettings &&
            <Settings
              onSettingChange={onSettingChange}
              social={localState.social}
              advertisement={localState.advertisement}
            />
          }
          <div className={CSS.Footer}>
            {!localState.showSettings &&
              <button className={CSS.SettingsButton} onClick={onChangeSettingsClick}>
                Change settings
              </button>
            }
            <RoundedButton pink edgeRounding="medium" size="S" className={CSS.AcceptButton} onClick={onAcceptClick} data-test-id="CookieOverlayAcceptButton">
              Accept cookies
            </RoundedButton>
          </div>
        </div>
      </aside>
    </Trek>
  );
}

export default ExcludeOnPlatforms(['cordova', 'server'])(CookieOverlay);
